import isEmpty from 'lodash/isEmpty';
import {
    getEventIdFromApp,
    getIsEnableTimedEntryFF,
} from '../../../selectors/app';
import { getEventId, isSeries, isSeriesParent } from '../../../selectors/event';
import { getEventDates } from '../../../selectors/event/getEventDates';
import { getSeriesEvents } from '../../../selectors/series';
import { CheckoutState } from '../../../state';

/**
 * Return true if user should see a back arrow on the tickets page header
 * and be able to go back to series page.
 *
 * If user lands on a series child event checkout widget directly, they shall
 * not be able to "go back" to parent series page.
 */
export const shouldShowBackToSeriesLink = (state: CheckoutState) => {
    const isEventAccessedDirectly =
        getEventIdFromApp(state) === getEventId(state);

    const hasSeriesDates =
        !isEmpty(getSeriesEvents(state)) ||
        (getIsEnableTimedEntryFF(state) &&
            !isEmpty(getEventDates(state)) &&
            !isEventAccessedDirectly);

    return isSeries(state) && !isSeriesParent(state) && hasSeriesDates;
};
